import {computed, type Ref} from 'vue';
import {fuzzyMatchItems, type FuzzyMatchResult} from './use-fuzzy-string-matching';

/** A custom answer string paired with its fuzzy match distance score */
export interface RatedCustomAnswer {
  customAnswer: string;
  distance: number;
}

/**
 * Composable for fuzzy matching custom answers with optimized performance.
 * Always uses fuzzy matching since custom answers benefit from flexible matching.
 */
export function useCustomAnswerFuzzyMatching(
  answers: Ref<string[]>,
  query: Ref<string>,
): Ref<RatedCustomAnswer[]> {
  return computed(() => {
    const results = fuzzyMatchItems(
      answers.value,
      query.value,
      (answer) => answer,
      {
        alwaysUseFuzzy: true, // Custom answers always benefit from fuzzy matching
        maxResults: 5,
        maxDistance: 3,
      },
    );

    // Convert to the expected interface format
    return results.map((result: FuzzyMatchResult<string>) => ({
      customAnswer: result.item,
      distance: result.distance,
    }));
  });
}
